<template>
  <a-modal
    :title="title"
    :visible="visible"
    @cancel="handleCancel"
    @ok="handleCancel"
    @close="handleCancel"
    width="1200px">
    <div class="order-info">
      <table>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="商户信息"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">企业用户号：</td>
                  <td class="data">
                    {{ this.merInfo.merNo}}
                  </td>
                  <td class="first">商户名称：</td>
                  <td class="data">
                    {{ this.merInfo.merName}}
                  </td>
                  <td class="first">所属集团：</td>
                  <td class="data">
                    {{ this.merInfo.groupId}}
                  </td>
                </tr>
                <tr>
                  <td class="first">顶层商户：</td>
                  <td class="data">
                    {{ this.merInfo.topMer}}
                  </td>
                  <td class="first">所在层级：</td>
                  <td class="data">
                    {{ this.merInfo.merLevel}}
                  </td>
                  <td class="first">可清算金额(分)：</td>
                  <td class="data">
                    {{ this.merInfo.canPayAmt}}
                  </td>
                </tr>
                <tr>
                  <td class="first">T0额度：</td>
                  <td class="data">
                    {{ this.merInfo.t0Amt}}
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>
      </table>
    </div>
    <div style="height: 25px">
    </div>
    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="handleCancel">
          {{$t('取消')}}
        </a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
import {getUmsMerInfo, getUmsMerBalance} from '@/api/merchant/extraApplyChinaums'
import CustomDictTag from "@/components/DictCustomTag/index.vue";

export default {
  name: 'balance',
  components: {CustomDictTag},
  props: {
  },
  data() {
    return {
      title:undefined,
      loading: false,
      visible: false,
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      filteredInfo: {},
      sortedInfo : {},
      total:0,
      queryParam: {
        id: undefined,
        payType: "01",
        pageNum: 1,
        pageSize: 10
      },
      merInfo: {
      },

      list: [],
    }
  },
  methods: {
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    handleCancel() {
      this.visible=false
      this.list=[]
      this.reset()
    },

    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    reset() {
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows
    },
    /** 修改按钮操作 */
    handleDetail(id) {
      getUmsMerBalance({"id":id, payType: "01"}).then(res => {
        this.merInfo = res.data
        this.visible = true;
      }).finally(() => {
        this.loading = false
      });
    },

  }
}
</script>
<style scoped>
.order-info {
  border: 1px solid #e8e8e8;
  margin-top: 40px;

  .info-table {
    tr {
      height: 50px;
    }
    td {
      display: table-cell;
      vertical-align: top;
      font-size: 16px;
    }

    .first {
      width: 100px;
    }

    .data {
      width: 300px;
    }
  }
}

</style>
